import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class TraspasoStoreService {
  TRASPASO_FONDS_DESTINATION: any;
  TRASPASO_FONDS_ORIGIN: any;

  TRASPASO_DATA:{
    activeCuc: boolean,
    cuc: string,
    idFondoDestino: string,
    idFondo: string,
    idCuentaParticipacion: string,
    traspasoTotal:  string,
    traspasoEnCuotas: string,
    importe: string,
    cuotas:  string,
    fechaSolicitud: string,
    cucDestino: string,
    distintaMoneda: string,
    idCuentaParticipacionDestino: string,
    tipoCambio: string
  }

  TRASPASO_CONFIRM_DATA:{}
  
  TRASPASO_OPERATION:{
    nroSolicitud: string;
    nroOperacion: string;
  }

  //
  constructor() {}
}
